import React, { FC, useCallback, useState } from 'react';
import { SCUIContent } from '../../../atomic/organisms';
import { useTranslation } from 'react-i18next';
import { SCUIGeneralDrawer } from '../../../atomic/molecules';
import { AddUpdateGlobalDataTokenDrawer } from './components/AddUpdateGlobalDataTokenDrawer';
import { Box, Grid } from '@mui/material';
import { SCUIBreadCrumb } from '../../../atomic/molecules';
import { SCUIButton } from '../../../atomic/atoms';
import GlobalDataTokenGrid from './components/GlobalDataTokenGrid';
import { PageUrl } from '../../../types/enums';
import Swal from 'sweetalert2';
import { GlobaldataCommand } from '../../../services/command';
import { GDT } from './globalDataTokenManagement.classes';

export const GlobalDataTokenManagement: FC<any> = () => {
    const { t } = useTranslation();
    const [open, setOpen] = React.useState({
        right: false,
    });
    const onDrawerOpen = useCallback(() => {
        setOpen((prevOpen) => ({ ...prevOpen, right: true }));
    }, []);
    const onDrawerClose = useCallback(() => {
        setOpen((prevOpen) => ({ ...prevOpen, right: false }));
    }, []);
    const [selectedTokenName, setSelectedTokenName] = React.useState<any>();
    const [refresh, setRefresh] = useState(false);
    const refreshTokenList = () => {
        setRefresh((prevLoading) => !prevLoading);
    };
    const handleOpenDrawer = () => {
        setSelectedTokenName([]);
        onDrawerOpen();
    };

    const reGenerateToken = (row: any) => {
        Swal.fire({
            title: 'Güncellemek istediğinizden emin misiniz?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Güncelle',
            cancelButtonText: 'Vazgeç',
            cancelButtonColor: '#d33',
        }).then((result) => {
            if (result.isConfirmed) {
                GlobaldataCommand.UpdateGlobaldataToken(row.id)
                    .then((res) => {
                        if (res) {
                            Swal.fire(t('general.success'), 'Güncellendi', 'success');
                        }
                    })
                    .catch((error) => {
                        if (error?.data?.Key) {
                            Swal.fire('Hata!', `${error?.data?.Key}`, 'error');
                        } else {
                            Swal.fire('Hata!', 'Token güncellenirken bir hata oluştu!', 'error');
                        }
                    })
                    .finally(() => {
                        refreshTokenList();
                    });
            }
        });
    };

    return (
        <SCUIContent className={GDT.page}>
            <Box className={GDT.root}>
                <Grid container direction="row" marginTop={'4rem'} className={GDT.breadcrumb}>
                    <SCUIBreadCrumb
                        title={t('globaldatatokenmanagement.headerName')}
                        componentLink={PageUrl.globaldatatokenmanagement.url}
                        dontShowHome={true}
                        homeIconLink={PageUrl.home.url}
                    />
                </Grid>
                <Box className={GDT.drawer}>
                    <SCUIGeneralDrawer
                        open={open['right']}
                        anchor="right"
                        width={'60rem'}
                        onClose={(event: any, reason: any) => {
                            if (reason === 'backdropClick') {
                                setOpen({ ...open, right: false });
                            }
                        }}
                    >
                        <AddUpdateGlobalDataTokenDrawer
                            selectedRow={selectedTokenName}
                            refresh={refreshTokenList}
                            onClose={onDrawerClose}
                        />
                    </SCUIGeneralDrawer>
                </Box>
                <Grid
                    container
                    justifyContent="flex-end"
                    className={GDT.toolbar}
                    size={{
                        xs: 12,
                        sm: 12,
                    }}
                >
                    <SCUIButton
                        className={GDT.btnAddToken}
                        text={t('globaldatatokenmanagement.addToken')}
                        sizeType="fixed"
                        type="primary"
                        size={'l'}
                        onClick={handleOpenDrawer}
                    ></SCUIButton>
                </Grid>
                <Grid
                    className={GDT.gridBox}
                    size={{
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                    }}
                >
                    <GlobalDataTokenGrid
                        selectedTokenName={selectedTokenName}
                        setTokenName={setSelectedTokenName}
                        onDrawerOpen={onDrawerOpen}
                        refresh={refresh}
                        reGenerateToken={reGenerateToken}
                    />
                </Grid>
            </Box>
        </SCUIContent>
    );
};
